import { signOut } from 'aws-amplify/auth'
import { Platform } from 'react-native'
import { eventEmitter } from './functions.utils'

/**
 * logoutAndReset
 * Centraliza el cierre de sesión y la notificación a la app para ejecutar la limpieza global.
 * La limpieza pesada (AsyncStorage.clear, DB/IndexedDB, borrar zips, etc) se ejecuta en Main.jsx al recibir el evento 'auth:signOut' o el Hub de Amplify.
 */
export async function logoutAndReset(): Promise<void> {
    try {
        await signOut()
    } catch {}
    try { eventEmitter.emit?.('auth:signOut') } catch {}
    try {
        if (Platform.OS === 'web' && typeof window !== 'undefined') {
            localStorage.setItem('__auth_event__', JSON.stringify({ type: 'signOut', ts: Date.now() }))
        }
    } catch {}
}

export default logoutAndReset
